import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const LoginErrorPopup = ({hideToaster }) => {
  return (
    <div className="messageSection">
      <div className="bgshowModal"></div>
      <div className="errorModal">
        <div className="tosterContent textCenter">
          <p>
            Please check your inbox for an email from SingleCare.
            <br />
            For your security, we need to verify your email address and reset
            your password.
          </p>
          <Link className="textCenter" onClick={hideToaster}>
            Dismiss
          </Link>
        </div>
      </div>
    </div>
  );
};

LoginErrorPopup.propTypes = {
  hideToaster: PropTypes.func
};

export default LoginErrorPopup;
